import React from "react";
import {
	Carousel,
	type CarouselApi,
	CarouselContent,
	CarouselNext,
	CarouselPrevious,
} from "../ui/carousel";

type AppProps = {
	count: number;
	children: React.ReactNode;
	className?: string;
};

const MediaCarousel: React.FunctionComponent<AppProps> = ({
	children,
	count,
	className,
}) => {
	const [api, setApi] = React.useState<CarouselApi>();
	const [current, setCurrent] = React.useState(0);

	// biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
	React.useEffect(() => {

		if (!api) {
			return;
		}

		setCurrent(api.selectedScrollSnap() + 1);

		api.on("select", () => {
			setCurrent(api.selectedScrollSnap() + 1);
		});
	}, [api]);
	React.useEffect(() => {
        if (count < current) {
            setCurrent(current - 1);
        }
    }, [count, current]);
	return (
		<Carousel className={className} setApi={setApi}>
			<CarouselContent>{children}</CarouselContent>
			{count > 1 && (
				<div className="flex justify-between items-center w-full">
					<CarouselPrevious />
					<span className="font-semibold">
						{current}/{count}
					</span>
					<CarouselNext />
				</div>
			)}
		</Carousel>
	);
};

export default MediaCarousel;
